import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFirefox = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_34298_5063)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9598 5.19849C14.6334 4.41337 13.9723 3.56574 13.4532 3.29783C13.8757 4.12612 14.1203 4.95699 14.2137 5.57708C14.2137 5.5783 14.2142 5.58133 14.2152 5.58958C13.3659 3.47293 11.926 2.61943 10.7501 0.761053C10.6908 0.667084 10.6312 0.572865 10.5732 0.473553C10.5437 0.422834 10.5161 0.371004 10.4905 0.318178C10.4417 0.223861 10.404 0.124166 10.3783 0.0211155C10.3784 0.0162369 10.3768 0.0114673 10.3736 0.00774353C10.3705 0.0040198 10.366 0.00161108 10.3612 0.000990505C10.3566 -0.000330168 10.3517 -0.000330168 10.3471 0.000990505C10.346 0.0013655 10.3445 0.00258425 10.3433 0.00302175C10.3417 0.003678 10.3396 0.005178 10.3378 0.00614675C10.3387 0.00502175 10.3404 0.0024905 10.341 0.00189675C8.45441 1.10677 7.81441 3.15068 7.75559 4.17327C7.00224 4.22506 6.28196 4.50262 5.68866 4.96977C5.62654 4.9173 5.5616 4.86827 5.49413 4.8229C5.32295 4.22402 5.31567 3.59017 5.47306 2.98752C4.70156 3.3388 4.1015 3.89408 3.66525 4.3844H3.66178C3.36406 4.0073 3.38506 2.76337 3.40203 2.50365C3.39847 2.48755 3.17994 2.61708 3.15131 2.63662C2.8886 2.82414 2.64299 3.03454 2.41738 3.26537C2.16063 3.52573 1.92605 3.80705 1.71606 4.1064C1.71606 4.10677 1.71584 4.10721 1.71572 4.10758C1.71572 4.10718 1.71594 4.10677 1.71606 4.1064C1.23314 4.79075 0.890631 5.56404 0.708344 6.38155C0.70475 6.39783 0.701719 6.41471 0.698219 6.43112C0.684094 6.49724 0.633219 6.82799 0.624313 6.89987C0.623625 6.9054 0.623312 6.91071 0.622656 6.91624C0.556882 7.2582 0.516149 7.60451 0.500781 7.9524C0.500781 7.96521 0.5 7.9779 0.5 7.99074C0.500125 12.138 3.86263 15.5 8.01025 15.5C11.7248 15.5 14.809 12.8035 15.4128 9.26152C15.4255 9.1654 15.4357 9.06877 15.4469 8.9718C15.5962 7.68399 15.4304 6.3304 14.9598 5.19849ZM6.30375 11.0764C6.33888 11.0932 6.37188 11.1116 6.40794 11.1276C6.40944 11.1287 6.4115 11.1298 6.41303 11.1308C6.37633 11.1132 6.3399 11.0951 6.30375 11.0764ZM14.2158 5.59143L14.2148 5.58415C14.2151 5.5868 14.2156 5.58958 14.216 5.59224L14.2158 5.59143Z",
				fill: "url(#paint0_linear_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9598 5.19753C14.6334 4.41241 13.9723 3.56478 13.4532 3.29688C13.8757 4.12516 14.1202 4.95603 14.2136 5.57612C14.2136 5.57431 14.214 5.57763 14.2147 5.58319C14.2151 5.58584 14.2156 5.58862 14.216 5.59128C14.9246 7.51222 14.5386 9.46559 13.9823 10.6592C13.1217 12.5061 11.0381 14.3989 7.77678 14.3066C4.25319 14.2068 1.149 11.5924 0.569531 8.16806C0.463937 7.62806 0.569531 7.35388 0.622656 6.91544C0.557937 7.25344 0.533281 7.35106 0.500781 7.95159C0.500781 7.96441 0.5 7.97709 0.5 7.98994C0.500062 12.1371 3.86256 15.499 8.01019 15.499C11.7247 15.499 14.8089 12.8025 15.4127 9.26056C15.4255 9.16444 15.4357 9.06781 15.4469 8.97084C15.5962 7.68303 15.4303 6.32944 14.9598 5.19753Z",
				fill: "url(#paint1_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9598 5.19753C14.6334 4.41241 13.9723 3.56478 13.4532 3.29688C13.8757 4.12516 14.1202 4.95603 14.2136 5.57612C14.2136 5.57431 14.214 5.57763 14.2147 5.58319C14.2151 5.58584 14.2156 5.58862 14.216 5.59128C14.9246 7.51222 14.5386 9.46559 13.9823 10.6592C13.1217 12.5061 11.0381 14.3989 7.77678 14.3066C4.25319 14.2068 1.149 11.5924 0.569531 8.16806C0.463937 7.62806 0.569531 7.35388 0.622656 6.91544C0.557937 7.25344 0.533281 7.35106 0.500781 7.95159C0.500781 7.96441 0.5 7.97709 0.5 7.98994C0.500062 12.1371 3.86256 15.499 8.01019 15.499C11.7247 15.499 14.8089 12.8025 15.4127 9.26056C15.4255 9.16444 15.4357 9.06781 15.4469 8.97084C15.5962 7.68303 15.4303 6.32944 14.9598 5.19753Z",
				fill: "url(#paint2_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3123 6.08334C11.3287 6.09484 11.3435 6.10628 11.3589 6.11772C11.1705 5.78321 10.9358 5.47694 10.6618 5.20797C8.32722 2.87372 10.0496 0.146656 10.3401 0.00815625C10.3409 0.00703125 10.3427 0.0045 10.3432 0.00390625C8.45663 1.10878 7.81662 3.15269 7.75781 4.17528C7.84531 4.16922 7.93256 4.16188 8.02163 4.16188C9.42947 4.16188 10.6557 4.93594 11.3123 6.08334Z",
				fill: "url(#paint3_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.026 6.54772C8.01372 6.73453 7.35369 7.37875 7.12287 7.37875C4.98728 7.37875 4.64062 8.67047 4.64062 8.67047C4.73522 9.75828 5.49253 10.6541 6.40972 11.1281C6.45156 11.1497 6.49391 11.1692 6.53628 11.1885C6.60893 11.2207 6.6825 11.2508 6.75687 11.2787C7.07136 11.3901 7.40076 11.4536 7.73409 11.4672C11.4772 11.6428 12.2024 6.99238 9.50112 5.64194C10.1929 5.52163 10.911 5.79984 11.312 6.08153C10.6553 4.93422 9.42916 4.16016 8.02134 4.16016C7.93228 4.16016 7.84506 4.1675 7.75753 4.17356C7.00417 4.22535 6.28389 4.50292 5.69059 4.97006C5.80509 5.06694 5.93434 5.19644 6.20666 5.46469C6.71609 5.96678 8.02322 6.48672 8.026 6.54772Z",
				fill: "url(#paint4_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.026 6.54772C8.01372 6.73453 7.35369 7.37875 7.12287 7.37875C4.98728 7.37875 4.64062 8.67047 4.64062 8.67047C4.73522 9.75828 5.49253 10.6541 6.40972 11.1281C6.45156 11.1497 6.49391 11.1692 6.53628 11.1885C6.60893 11.2207 6.6825 11.2508 6.75687 11.2787C7.07136 11.3901 7.40076 11.4536 7.73409 11.4672C11.4772 11.6428 12.2024 6.99238 9.50112 5.64194C10.1929 5.52163 10.911 5.79984 11.312 6.08153C10.6553 4.93422 9.42916 4.16016 8.02134 4.16016C7.93228 4.16016 7.84506 4.1675 7.75753 4.17356C7.00417 4.22535 6.28389 4.50292 5.69059 4.97006C5.80509 5.06694 5.93434 5.19644 6.20666 5.46469C6.71609 5.96678 8.02322 6.48672 8.026 6.54772Z",
				fill: "url(#paint5_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.33728 4.72053C5.38959 4.75427 5.44147 4.78865 5.49294 4.82366C5.32176 4.22478 5.31449 3.59093 5.47187 2.98828C4.70037 3.33956 4.10031 3.89484 3.66406 4.38516C3.70016 4.38413 4.7895 4.36453 5.33728 4.72053Z",
				fill: "url(#paint6_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.56769 8.17085C1.14716 11.5952 4.25135 14.2096 7.77494 14.3094C11.0362 14.4017 13.1198 12.5088 13.9804 10.662C14.5367 9.46829 14.9228 7.51516 14.2142 5.59407L14.2139 5.59326L14.2129 5.58597C14.2121 5.58041 14.2117 5.5771 14.2118 5.57891C14.2118 5.58013 14.2123 5.58316 14.2133 5.59141C14.4796 7.33082 13.5948 9.01591 12.2117 10.1553L12.2075 10.1651C9.51235 12.3595 6.93331 11.4891 6.41113 11.1328C6.37442 11.1151 6.33796 11.0969 6.30175 11.0783C4.73044 10.3274 4.08131 8.89585 4.2205 7.66816C2.89372 7.66816 2.44131 6.54913 2.44131 6.54913C2.44131 6.54913 3.63253 5.69979 5.2025 6.43847C6.65656 7.12263 8.02213 6.54919 8.02228 6.54913C8.0195 6.48813 6.71238 5.96819 6.20281 5.46613C5.93053 5.19788 5.80125 5.06854 5.68675 4.97151C5.62463 4.91904 5.55969 4.87001 5.49222 4.82463C5.4407 4.78971 5.38881 4.75533 5.33656 4.72151C4.78881 4.36551 3.69944 4.3851 3.66335 4.38604H3.65988C3.36216 4.00894 3.38316 2.76501 3.40013 2.50529C3.39656 2.48919 3.17803 2.61872 3.14941 2.63826C2.88669 2.82578 2.64109 3.03618 2.41547 3.26701C2.15872 3.52743 1.92414 3.80881 1.71416 4.10822C1.71416 4.1086 1.71394 4.10904 1.71381 4.10941C1.71381 4.10901 1.71403 4.1086 1.71416 4.10822C1.23123 4.79258 0.888727 5.56586 0.70644 6.38338C0.702846 6.39966 0.436127 7.56594 0.56769 8.17085Z",
				fill: "url(#paint7_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.659 5.2058C10.933 5.47478 11.1677 5.78104 11.3562 6.11555C11.3975 6.14662 11.4361 6.17759 11.4689 6.2078C13.1715 7.77655 12.2794 9.9953 12.2129 10.1534C13.596 9.01405 14.4808 7.32896 14.2145 5.58955C13.3652 3.47293 11.9253 2.61943 10.7494 0.761053C10.6901 0.667084 10.6305 0.572866 10.5725 0.473553C10.543 0.422834 10.5154 0.371004 10.4898 0.318178C10.441 0.223861 10.4033 0.124166 10.3776 0.0211155C10.3777 0.0162369 10.3761 0.0114673 10.3729 0.00774353C10.3698 0.0040198 10.3653 0.00161108 10.3605 0.000990505C10.3559 -0.000330168 10.351 -0.000330168 10.3464 0.000990505C10.3453 0.0013655 10.3438 0.00258425 10.3427 0.00302176C10.341 0.003678 10.3389 0.00517801 10.3372 0.00614676C10.0468 0.144522 8.32444 2.87158 10.659 5.2058Z",
				fill: "url(#paint8_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4679 6.20828C11.4351 6.17806 11.3965 6.14709 11.3552 6.11603C11.3399 6.10453 11.3249 6.09309 11.3085 6.08165C10.9075 5.79997 10.1894 5.52175 9.49766 5.64206C12.1989 6.9925 11.4737 11.6429 7.73062 11.4673C7.39729 11.4537 7.06789 11.3902 6.75341 11.2788C6.67904 11.2509 6.60548 11.2208 6.53281 11.1887C6.49044 11.1693 6.44809 11.1498 6.40625 11.1282C6.40775 11.1292 6.40981 11.1304 6.41134 11.1313C6.93353 11.4876 9.51256 12.3581 12.2077 10.1636L12.2119 10.1538C12.2784 9.9959 13.1705 7.77706 11.4679 6.20828Z",
				fill: "url(#paint9_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.64091 8.6681C4.64091 8.6681 4.98756 7.37638 7.12316 7.37638C7.35403 7.37638 8.01406 6.73216 8.02628 6.54535C8.0385 6.35854 6.66066 7.11885 5.2065 6.4347C3.63653 5.69601 2.44531 6.54535 2.44531 6.54535C2.44531 6.54535 2.89772 7.66438 4.2245 7.66438C4.08534 8.89207 4.73447 10.3238 6.30575 11.0745C6.34088 11.0913 6.37388 11.1096 6.40994 11.1257C5.49281 10.6517 4.7355 9.75591 4.64091 8.6681Z",
				fill: "url(#paint10_radial_34298_5063)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9597 5.19849C14.6333 4.41337 13.9722 3.56574 13.4531 3.29783C13.8756 4.12612 14.1201 4.95699 14.2136 5.57708C14.2136 5.5783 14.214 5.58133 14.215 5.58958C13.3658 3.47293 11.9258 2.61943 10.75 0.761053C10.6906 0.667084 10.6311 0.572865 10.5731 0.473553C10.5436 0.422834 10.516 0.371004 10.4904 0.318178C10.4416 0.223861 10.4039 0.124166 10.3781 0.0211155C10.3783 0.0162369 10.3767 0.0114673 10.3735 0.00774353C10.3703 0.0040198 10.3659 0.00161108 10.3611 0.000990505C10.3565 -0.000330168 10.3516 -0.000330168 10.347 0.000990505C10.3459 0.0013655 10.3443 0.00258425 10.3432 0.00302175C10.3416 0.003678 10.3395 0.005178 10.3377 0.00614675C10.3386 0.00502175 10.3403 0.0024905 10.3408 0.00189675C8.45428 1.10677 7.81428 3.15068 7.75547 4.17327C7.84297 4.16721 7.93022 4.15987 8.01928 4.15987C9.42719 4.15987 10.6534 4.93393 11.3099 6.08124C10.9089 5.79955 10.1908 5.52133 9.49906 5.64165C12.2003 6.99208 11.4752 11.6425 7.73203 11.4669C7.3987 11.4533 7.06929 11.3898 6.75481 11.2784C6.68044 11.2505 6.60688 11.2204 6.53422 11.1882C6.49184 11.1689 6.4495 11.1494 6.40766 11.1278C6.40916 11.1288 6.41122 11.13 6.41275 11.1309C6.37605 11.1132 6.33959 11.0951 6.30337 11.0764C6.3385 11.0932 6.3715 11.1116 6.40756 11.1276C5.49038 10.6536 4.73306 9.75786 4.63847 8.67005C4.63847 8.67005 4.98513 7.37833 7.12072 7.37833C7.35159 7.37833 8.01162 6.73412 8.02384 6.5473C8.02106 6.4863 6.71394 5.96637 6.20437 5.4643C5.93209 5.19605 5.80281 5.06671 5.68831 4.96968C5.62619 4.91721 5.56125 4.86818 5.49378 4.8228C5.3226 4.22393 5.31533 3.59008 5.47272 2.98743C4.70122 3.33871 4.10116 3.89399 3.66491 4.3843H3.66144C3.36372 4.00721 3.38472 2.76327 3.40169 2.50355C3.39812 2.48746 3.17959 2.61699 3.15097 2.63652C2.88825 2.82404 2.64265 3.03445 2.41703 3.26527C2.16036 3.52567 1.92585 3.80702 1.71594 4.1064C1.71594 4.10677 1.71572 4.10721 1.71559 4.10758C1.71559 4.10718 1.71581 4.10677 1.71594 4.1064C1.23301 4.79075 0.890506 5.56404 0.708219 6.38155C0.704625 6.39783 0.701594 6.41471 0.698094 6.43112C0.683969 6.49724 0.620406 6.83277 0.611531 6.90474C0.610844 6.91027 0.612188 6.89924 0.611531 6.90474C0.553567 7.25147 0.516583 7.60137 0.500781 7.95255C0.500781 7.96537 0.5 7.97805 0.5 7.9909C0.5 12.138 3.8625 15.5 8.01013 15.5C11.7247 15.5 14.8089 12.8035 15.4127 9.26152C15.4254 9.1654 15.4356 9.06877 15.4468 8.9718C15.5961 7.68399 15.4303 6.3304 14.9597 5.19849ZM14.2147 5.58415C14.2151 5.5868 14.2155 5.58958 14.2159 5.59224L14.2157 5.59143L14.2147 5.58415Z",
				fill: "url(#paint11_linear_34298_5063)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_34298_5063",
			x1: 1309.26,
			y1: 240.249,
			x2: 103.363,
			y2: 1403.51,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .05,
					stopColor: "#FFF44F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .37,
					stopColor: "#FF980E"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .53,
					stopColor: "#FF3647"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7,
					stopColor: "#E31587"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint1_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(1049.21 -154.107) scale(1536.01 1561.87)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .13,
					stopColor: "#FFBD4F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .28,
					stopColor: "#FF980E"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .47,
					stopColor: "#FF3750"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .78,
					stopColor: "#EB0878"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .86,
					stopColor: "#E50080"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint2_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(603.115 491.382) scale(1574.41 1561.87)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .3,
					stopColor: "#960E18"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .35,
					stopColor: "#B11927",
					stopOpacity: .74
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .43,
					stopColor: "#DB293D",
					stopOpacity: .34
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#F5334B",
					stopOpacity: .09
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .53,
					stopColor: "#FF3750",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint3_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(180.612 -73.3619) scale(504.157 855.934)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .13,
				stopColor: "#FFF44F"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .53,
				stopColor: "#FF980E"
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint4_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(156.48 809.27) scale(667.134 731.187)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .35,
					stopColor: "#3A8EE6"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .67,
					stopColor: "#9059FF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C139E6"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint5_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(316.396 245.452) scale(354.248 431.4)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .21,
				stopColor: "#9059FF",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .97,
				stopColor: "#6E008B",
				stopOpacity: .6
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint6_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(387.728 -180.549) scale(530.374 532.259)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .1,
				stopColor: "#FFE226"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .79,
				stopColor: "#FF7139"
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint7_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(1182.19 -481.655) scale(2532.12 2125.58)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .11,
					stopColor: "#FFF44F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .46,
					stopColor: "#FF980E"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .72,
					stopColor: "#FF3647"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .9,
					stopColor: "#E31587"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint8_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientTransform: "matrix(175.321 783.99 -3522.11 173.989 196.898 31.3204)",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FFF44F" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .3,
					stopColor: "#FF980E"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .57,
					stopColor: "#FF3647"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .74,
					stopColor: "#E31587"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint9_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(121.662 -249.007) scale(1453.81 1428.27)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .14,
					stopColor: "#FFF44F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .48,
					stopColor: "#FF980E"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .66,
					stopColor: "#FF3647"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .9,
					stopColor: "#E31587"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint10_radial_34298_5063",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(891.506 -217.15) scale(1747.43 1563.28)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .09,
				stopColor: "#FFF44F"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .63,
				stopColor: "#FF980E"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint11_linear_34298_5063",
			x1: 1200.5,
			y1: 216.999,
			x2: 236.201,
			y2: 1270.61,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .17,
				stopColor: "#FFF44F",
				stopOpacity: .8
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .6,
				stopColor: "#FFF44F",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_34298_5063",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		})
	] })]
});
export default SvgFirefox;
